var React = require('react');

function Flare3 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M38.901 42.0122C38.901 42.0122 284.089 -52.5152 375.099 42.0122C462.626 132.922 375.099 364.988 375.099 364.988C375.099 364.988 129.911 459.515 38.901 364.988C-48.6262 274.078 38.901 42.0122 38.901 42.0122Z","fill":"#E9896A","fillOpacity":"0.74"}));
}

Flare3.defaultProps = {"width":"414","height":"407","viewBox":"0 0 414 407","fill":"none"};

module.exports = Flare3;

Flare3.default = Flare3;
